import React from "react";
import { Box, Typography } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import VerticalBar from "./VerticalBar";
import { derinColors, derinTypography } from "./theme";

interface SectionHeaderProps {
  title: string;
  commentsCount: number;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, commentsCount }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "8px",
      height: "32px",
    }}
  >
    <VerticalBar />
    <Typography
      sx={{
        ...derinTypography.heading,
        color: derinColors.textPrimary,
      }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <ChatBubbleOutlineIcon
        sx={{ color: derinColors.textSecondary, width: 16, height: 16 }}
      />
      <Typography
        sx={{
          ...derinTypography.body,
          color: derinColors.textPrimary,
        }}
      >
        {commentsCount} Comments
      </Typography>
    </Box>
  </Box>
);

export default SectionHeader;
